export default __webpack_public_path__ + "d9232aca2dea896d6b0f85ed606414c6.svg";